import styled from 'styled-components'

const FormContainer = styled.div`
  height: 100%;
  padding-bottom: 80px;
  overflow-y: auto;
`

export default FormContainer
